var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner",class:['spinner--' + _vm.type, { 'spinner--mask': _vm.mask }],style:({ height: _vm.type === 'block' && _vm.height })},[_c('div',{staticClass:"spinner__sign"})])}
var staticRenderFns = []

export { render, staticRenderFns }